import { SupportedLanguage } from "../stores/language_store";

export const translations: Record<string, Record<SupportedLanguage, string>> = {
  welcome_title: {
    french: "Bienvenue sur les applis de Marjorie",
    english: "Welcome to the apps of Marjorie",
  },
  connection: {
    french: "Connectez-vous",
    english: "Sign in",
  },
  welcome: {
    french: "Bonjour",
    english: "Welcome",
  },
  email: {
    french: "Votre email",
    english: "E-mail",
  },
  login: {
    french: "Connexion",
    english: "Login",
  },
  logout: {
    french: "Déconnexion",
    english: "Logout",
  },
  timeConnection: {
    french: "Vous etes connecte depuis",
    english: "You are connected since",
  },
  newJoke: {
    french: "Nouvelle blague",
    english: "New joke",
  },
  response: {
    french: "Réponse",
    english: "Response",
  },
  home: {
    french: "Accueil",
    english: "Home",
  },
  jokes: {
    french: "Blagues",
    english: "Jokes",
  },
  new_cat: {
    french: "Nouveau chat",
    english: "New cat",
  },
  cat_generator: {
    french: "Générateur de chat",
    english: "Cat generator",
  },
  rps: {
    french: "Pierre Feuille Ciseaux",
    english: "Rock Paper Scissors",
  },
  contact_form: {
    french: "Formulaire de Contact",
    english: "Contact form",
  },
  history_cat: {
    french: "Historique de chats",
    english: "Cat history",
  },
  lol_char: {
    french: "Personnages de LOL",
    english: "LOL characters",
  },
  role_filter: {
    french: "Filtrer par rôle :",
    english: "Filter by role :",
  },
  name_filter: {
    french: "Filtrer par nom",
    english: "Filter by name",
  },
  return: {
    french: "Retour",
    english: "Return",
  },
  role: {
    french: "Rôle :",
    english: "Role :",
  },
  spells_list: {
    french: "Liste des Sorts :",
    english: "Spells list :",
  },
  passive: {
    french: "Passif",
    english: "Passive",
  },
  lol_tag_fighter: {
    french: "Combattant",
    english: "Fighter",
  },
  lol_tag_mage: {
    french: "Magicien",
    english: "Mage",
  },
  lol_tag_assassin: {
    french: "Assassin",
    english: "Assassin",
  },
  lol_tag_marksman: {
    french: "Tireur",
    english: "Marksman",
  },
  lol_tag_tank: {
    french: "Tank",
    english: "Tank",
  },
  lol_tag_support: {
    french: "Support",
    english: "Support",
  },
  rock: {
    french: "Pierre",
    english: "Rock",
  },
  paper: {
    french: "Feuille",
    english: "Paper",
  },
  scissors: {
    french: "Ciseaux",
    english: "Scissors",
  },
  user_choice: {
    french: "Vous avez choisi : ",
    english: "You chose : ",
  },
  computer_choice: {
    french: "L'ordinateur a choisi : ",
    english: "Computer chose : ",
  },
  user_result: {
    french: "Votre résultat : ",
    english: "Your result : ",
  },
  computer_result: {
    french: "Résultat de l'ordinateur : ",
    english: "Computer result : ",
  },
  replay: {
    french: "Rejouer",
    english: "Replay",
  },
  win: {
    french: "Vous gagnez !",
    english: "You win !",
  },
  lose: {
    french: "Vous perdez !",
    english: "You lose !",
  },
  tied: {
    french: "Égalité",
    english: "Tied",
  },
  contact_us: {
    french: "Nous contacter",
    english: "Contact us",
  },
  send: {
    french: "Envoyer",
    english: "Send",
  },
  first_name: {
    french: "Prénom",
    english: "First name",
  },
  last_name: {
    french: "Nom de famille",
    english: "Last name",
  },
  message: {
    french: "Votre message ici",
    english: "Your message here",
  },
  text: {
    french: "Texte",
    english: "Text",
  },
  to_do_list: {
    french: "Ma Liste de tâches",
    english: "To do list",
  },
  add_task: {
    french: "Entrer une tâche",
    english: "Add a task",
  },
  to_do: {
    french: "A Faire",
    english: "To do",
  },
  done: {
    french: "Réalisé",
    english: "Done",
  },
  no_task: {
    french: "Pas de tâche à réaliser",
    english: "No tasks defined",
  },
};
